export default __webpack_public_path__ + "static/media/export.ed8a8648.svg";